module.exports = __webpack_public_path__ + "static/media/left-scroll.934b68ef.svg";